module.exports = __webpack_public_path__ + "static/media/C_10.27fadfc3.png";